import { memo } from 'motion-utils';
import { supportsFlags } from './flags.mjs';

function memoSupports(callback, supportsFlag) {
  var memoized = memo(callback);
  return function () {
    var _supportsFlags$suppor;

    return (_supportsFlags$suppor = supportsFlags[supportsFlag]) !== null && _supportsFlags$suppor !== void 0 ? _supportsFlags$suppor : memoized();
  };
}

export { memoSupports };